var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-list",
        [
          _c(
            "v-list-item",
            [
              _c("SoliText", {
                attrs: {
                  label: "Venue Name",
                  icon: "storefront",
                  rules: [() => !!_vm.value.name || "Venue name is required"],
                },
                model: {
                  value: _vm.value.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "name", $$v)
                  },
                  expression: "value.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c("SoliAddress", {
                attrs: {
                  rules: [() => !!_vm.value.address || "Address is required"],
                },
                on: {
                  setAddress: function ($event) {
                    _vm.value.address = `${$event.address}, ${$event.city}`
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }